/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1242
 */

var r = require(/* 476 */"../../1282/476")
module.exports = r("document", "documentElement")
